import { Component, OnInit, ViewChild, Inject, HostListener } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TmcTableComponent, TmcTableModel } from '@sdbn/common';

interface ITableSelectionDialogDataConfirmCallback {
    (tableModel: TmcTableModel);
}

export class TableSelectionDialogData {
    cancelDisabled?: boolean = false;
    tableModel: TmcTableModel;
    confirmCallback: ITableSelectionDialogDataConfirmCallback;
    title: string;
}

@Component({
    selector: 'app-table-selection-dialog',
    templateUrl: './table-selection-dialog.component.html',
    styleUrls: ['./table-selection-dialog.component.scss']
})
export class TableSelectionDialogComponent implements OnInit {
    @HostListener('window:keyup.esc') onKeyUp() {
        if (!this.data.cancelDisabled) {
            this.dialogRef.close();
        }
    }

    @ViewChild('tmcTableComponent', { static: true }) tmcTableComponent: TmcTableComponent;
    tableModel: TmcTableModel;

    constructor(
        public dialogRef: MatDialogRef<TableSelectionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: TableSelectionDialogData) {
        this.dialogRef.disableClose = true; // Wieso auf true?
    }

    ngOnInit() {
        if (this.data.tableModel != null) {
            this.tableModel = this.data.tableModel;
        } else {
            this.tableModel = new TmcTableModel();
        }
    }

    isCancelDisabled() {
        return this.data.cancelDisabled;
    }

    cancelDialog() {
        this.dialogRef.close();
    }

    confirm() {
        this.dialogRef.close();
        this.data.confirmCallback(this.tableModel);
    }
}

